/**
 * Browser error tracking with Sentry (free Developer plan).
 *
 * Off unless REACT_APP_SENTRY_DSN is set at build time: the Sentry code is then
 * never downloaded. When on, crashes and unhandled errors are sent with the
 * page and the signed-in user's id only (no email, names, inputs or replays).
 */
let sentry = null;

const isEnabled = (env = process.env) => Boolean(env.REACT_APP_SENTRY_DSN);

const initSentry = async (env = process.env) => {
  if (sentry || !isEnabled(env)) {
    return sentry;
  }
  const Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: env.REACT_APP_SENTRY_DSN,
    environment: env.REACT_APP_ENV || env.NODE_ENV,
    sendDefaultPii: false,
    tracesSampleRate: 0,
  });
  sentry = Sentry;
  return sentry;
};

/** Report an error caught by an error boundary (no-op when off). */
const captureError = (error, extra = {}) => {
  if (!sentry) {
    return;
  }
  sentry.captureException(error, { extra });
};

/** Tag later reports with the signed-in user's id (null to clear). */
const setSentryUser = (userId) => {
  if (!sentry) {
    return;
  }
  sentry.setUser(userId ? { id: String(userId) } : null);
};

/** For tests: forget the client. */
const resetSentry = () => {
  sentry = null;
};

export { initSentry, captureError, setSentryUser, isEnabled, resetSentry };
